<template>
  <v-row>
    <v-col cols="12">
      <v-list-item-content>
        <v-list-item-title v-text="indent(process)" class="menu-list-item"></v-list-item-title>
      </v-list-item-content>
    </v-col>
  </v-row>  
</template>

<script>
export default {
  name: 'ProcessMenuItem',
  props: {
    process: Object,
  },
  methods: {
    indent(process) {
      var level = 1
      var tmp = process
      console.log(process.name)
      while (tmp.parent) {
        tmp = tmp.parent
        level++
      }
      let label = '**'.repeat(level / 2 - 1) + ' '
      return label + process.name
    },
  },
}
</script>


<style lang="scss">
  @import "@/sass/header.scss";
</style>
